import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss'
})
export class CookieConsentComponent implements OnInit {
  isVisible = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('articix-cookie-consent');
    if (!cookieConsent) {
      // Show banner after 1 second
      setTimeout(() => {
        this.isVisible = true;
      }, 1000);
    }
  }

  acceptAllCookies() {
    localStorage.setItem('articix-cookie-consent', JSON.stringify({
      analytics: true,
      marketing: true,
      essential: true,
      timestamp: new Date().toISOString()
    }));
    this.isVisible = false;
    this.loadAnalytics();
  }

  acceptEssentialOnly() {
    localStorage.setItem('articix-cookie-consent', JSON.stringify({
      analytics: false,
      marketing: false,
      essential: true,
      timestamp: new Date().toISOString()
    }));
    this.isVisible = false;
  }

  rejectAll() {
    localStorage.setItem('articix-cookie-consent', JSON.stringify({
      analytics: false,
      marketing: false,
      essential: true,
      timestamp: new Date().toISOString()
    }));
    this.isVisible = false;
  }

  private loadAnalytics() {
    // This would load analytics scripts if user consents
    const consent = localStorage.getItem('articix-cookie-consent');
    if (consent) {
      const parsed = JSON.parse(consent);
      if (parsed.analytics) {
        // Google Analytics would be loaded here
        // gtag is already loaded in index.html
      }
    }
  }
}
